<template>
    <!-- 操作报警开关的对话框  传参仅能通过bus进行  防止重复渲染 -->
    <modal :visible.sync="visible" appendToBody width="400px" :title="title">
        <el-form ref="form" :model="model" label-width="100px" :rules="rules">
            <el-form-item :label="$t('public.switch')" prop="event">
                <el-switch v-model="model.event" :active-value="1" :inactive-value="0"> </el-switch>
            </el-form-item>

            <!-- 关闭才需要附加说明 -->
            <el-form-item :label="$t('integration.explain')" prop="reasonId" v-if="!model.event">
                <el-select v-model="model.reasonId" :placeholder="$t('integration.please_select')">
                    <el-option :label="reason.title" :value="reason.id" :key="reason.id"
                        v-for="reason in reasonList"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('integration.describe')" prop="desc">
                <el-input type="textarea" :maxlength="250" style="width: 74%;" class="input-width" v-model="model.desc"
                    placeholder=""> </el-input>
            </el-form-item>
        </el-form>

        <template #footer>
            <el-button type="primary" @click="save">{{ $t('public.save') }}</el-button>
            <el-button @click="visible = false">{{ $t('public.cancel') }}</el-button>
        </template>
    </modal>
</template>

<script>
import bus from '@/utils/bus'
import { editAlarmSwitch as editCarrierAlarmSwitch } from '@/api/modules/carrier'
import { editAlarmSwitch as editTriggerAlarmSwitch } from '@/api/modules/alarm'
import { exReasons } from '@/api/modules/abnormal'
export default {
    computed: {
        title() {
            return ((this.carrierInfo && this.carrierInfo.keycode) || '') + $t('integration.alarm_switch')
        },
        rules() {
            return {
                reasonId: [{ required: true, message: $t('integration.please_select_explain'), trigger: 'blur' }]
            }
        }
    },
    watch: {
        'model.sceneId': {
            handler() {
                this.getExReason(this.model.sceneId)
            }
        }
    },
    data() {
        return {
            rawModel: {},
            model: {
                event: 0,
                desc: '',
                reasonId: 0
            },
            visible: false,
            sceneId: null,
            reasonList: []
        }
    },
    methods: {
        async save() {
            await this.$refs.form.validate()
            const { triggerIds, carrierIds, reasonId, desc } = this.model
            // 因为event取反会是true或者false的值 后端只接受0或1 需要做处理
            let { event } = this.model
            event = event ? 1 : 0


            // if (carrierIds && carrierIds.length === 1 && event === this.rawModel.event) {
            //     return this.visible = false
            // }
            if (carrierIds) {
                editCarrierAlarmSwitch(this.model.type, { event, carrierIds, reasonId, desc }).then(res => {
                    this.$message.success($t('integration.operation_successful'))
                    if (this.model.getList) {
                        this.model.getList(this.model)
                    }
                    this.visible = false
                })
            } else if (triggerIds) {
                editTriggerAlarmSwitch({ event, triggerIds, reasonId, desc }).then(res => {
                    this.$message.success($t('integration.operation_successful'))
                    if (this.model.getList) {
                        this.model.getList()
                    }
                    this.visible = false
                })
            }
        },
        getExReason(scopeId) {
            exReasons({ scope: scopeId }).then(res => {
                this.reasonList = res.result
                // if (this.reasonList.length) {
                //     this.model.reasonId = this.reasonList[0].id;
                // }
            })
        }
    },
    mounted() {
        // carrierInfo 包括keycode和id
        bus.$on('alarmSwitchDialog', data => {
            this.visible = true

            this.rawModel = { ...data }
            this.model = { ...data }
        })
    },
    beforeDestroy() {
        bus.$off('alarmSwitchDialog')
    }
}
</script>
